import React, { useState, useEffect } from "react";
import "react-tabs/style/react-tabs.css";
import { faBars, faSearch, faSort } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { utilGetDocumentFilters } from "../../../util/UtilsFirebase";
import "./VentasOrdenes.css";
import { Table, Form, Pagination, Button, Modal } from "react-bootstrap";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import moment from "moment";
import { useAuthContext } from "../../../hooks/useAuthContext";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { projectFirestore } from "../../../firebase/config";

export default function VentasOrdenes() {
  const { register } = useAuthContext();
  const [data, setData] = useState([]);
  const [sortType, setSortType] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const [filterText, setFilterText] = useState("");
  const elementsPerPage = 7;
  const [dateRange, setDateRange] = useState([]);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [detalleOrden, setDetalleOrden] = useState([]);

  const handleDateRangeChange = (dateRangeP) => {
    let filtros = [];
    console.log(dateRangeP);
    if (dateRangeP) {
      filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        { campo: "fecha", operador: ">=", valor: dateRangeP[0] },
        { campo: "fecha", operador: "<=", valor: dateRangeP[1] },
      ];
    } else {
      filtros = [{ campo: "puesto", operador: "==", valor: register.id }];
    }
    const fetchOrders = utilGetDocumentFilters("turnero", filtros);
    fetchOrders
      .then((fetchedOrders) => {
        setData(fetchedOrders);
      })
      .catch((error) => {
        console.error("Error fetching orders:", error);
      });
    setDateRange({ dateRange });
  };

  const handleFilterTextChange = (event) => {
    setFilterText(event.target.value);
  };

  const filteredData = data.filter((item) => {
    const date = new Date(item.fecha.toDate());
    if (dateRange.dateRange) {
      return (
        item.number
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.user_name
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.ordenadoPor
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.status
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        (item.total
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) &&
          date >= dateRange.dateRange[0] &&
          date <= dateRange.dateRange[1])
      );
    } else {
      return (
        item.number
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.user_name
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.ordenadoPor
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.total
          .toString()
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.status.toString().toLowerCase().includes(filterText.toLowerCase())
      );
    }
  });

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return filteredData.slice(startIndex, endIndex);
  };

  function mostrarDetalles(item) {
    setDetalleOrden(item);
    setMostrarDetalle(true);
  }

  useEffect(() => {
    const filtros = [{ campo: "puesto", operador: "==", valor: register.id }];
    let q = query(collection(projectFirestore, "turnero"));
    filtros.forEach((filtro) => {
      const { campo, operador, valor } = filtro;
      q = query(q, where(campo, operador, valor));
    });
    q = query(q, orderBy("fecha", "desc"));
    onSnapshot(q, (docs) => {
      const documentosColeccion = [];
      docs.docs.forEach((docu) => {
        const data = docu.data();
        data.id = docu.id;
        documentosColeccion.push(data);
      });
      setData(documentosColeccion);
    });
  }, [register.id]);

  return (
    <div>
      <br />
      <h4 className="page-title">VENTAS / ORDENES</h4>
      <br />
      <br />
      <div className="container">
        <>
          <div className="mrg-titulo mrg-tbl"></div>
          <div className="row">
            <div className="col-sm-3">
              <div className="input-group">
                <Form.Control
                  className="form-control border-end-0 border rounded-pill"
                  type="text"
                  aria-describedby="search-icon"
                  placeholder="Busqueda general"
                  value={filterText}
                  onChange={handleFilterTextChange}
                />
                <span className="input-group-append">
                  <button
                    className="btn btn-outline-secondary bg-white border-start-0 border rounded-pill ms-n3"
                    type="button"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </button>
                </span>
              </div>
            </div>

            <div className="col-sm-3">
              <div className="input-group">
                <DateRangePicker
                  appearance="default"
                  placeholder="Filtar por rango de fechas"
                  onChange={handleDateRangeChange}
                  style={{ width: 230 }}
                />
              </div>
            </div>

            <div className="col-lg-12 mrg-tbl">
              <Table striped bordered hover border="2">
                <thead>
                  <tr>
                    <th
                      onClick={() =>
                        setSortType(sortType === "asc" ? "desc" : "asc")
                      }
                    >
                      {" "}
                      <FontAwesomeIcon icon={faSort} /> Fecha
                    </th>
                    <th>No. Folio</th>
                    <th>No. Orden</th>
                    <th>Cliente</th>
                    <th>Tipo de Orden</th>
                    <th>Tipo de Pago</th>
                    <th>Subtotal</th>
                    <th>Puntos obtenidos</th>
                    <th>Puntos usados</th>
                    <th>Total</th>
                    <th>Estatus</th>
                    <th>Detalles</th>
                  </tr>
                </thead>
                <tbody>
                  {getElementsForPage(currentPage)
                    .sort()
                    .map((val, key) => {
                      return (
                        <tr key={key}>
                          <td>
                            {moment(val.fecha.toDate()).format("DD/MM/YYYY")}
                          </td>
                          <td>{val.folio}</td>
                          <td>{val.number.toString()}</td>
                          <td>
                            {val.user_name ? val.user_name : "SIN NOMBRE"}
                          </td>
                          <td>{val.ordenadoPor}</td>
                          <td>{val.tipo_pago}</td>
                          <td>{val.total.toFixed(2)}</td>
                          <td>
                            {val.puntosgenerados ? val.puntosgenerados : 0}
                          </td>
                          <td>{val.puntosusados ? val.puntosusados : 0}</td>
                          <td>
                            {val.puntosusados
                              ? (
                                  val.total -
                                  val.puntosusados *
                                    (val.equivalenciapuntos
                                      ? parseFloat(val.equivalenciapuntos)
                                      : 1)
                                ).toFixed(2)
                              : val.total.toFixed(2)}
                          </td>
                          <td>{val.status}</td>
                          <td>
                            <Button
                              variant="primary"
                              style={{
                                minWidth: "50px !important",
                                marginLeft: 20,
                              }}
                              onClick={() => {
                                mostrarDetalles(val);
                              }}
                            >
                              <FontAwesomeIcon icon={faBars} />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
              <Pagination>
                {Array.from({
                  length: Math.ceil(filteredData.length / elementsPerPage),
                }).map((page, index) => (
                  <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    className={index + 1 === currentPage ? "btn-paginado" : ""}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </div>
          </div>
        </>
      </div>
      <Modal
        show={mostrarDetalle}
        onHide={() => {
          setDetalleOrden([]);
          setMostrarDetalle(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Detalles de la Orden</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <strong>Atendio: </strong>
                {detalleOrden.atendio ? detalleOrden.atendio : ""}
                <br />
                <br /> */}
          <Table striped bordered hover border="2">
            <thead>
              <tr>
                <th>Platillo</th>
                <th>Costo</th>
                <th>Cantidad</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {detalleOrden.detalle
                ? detalleOrden.detalle.map((element) => {
                    return (
                      <tr>
                        <td>{element.name.toString()}</td>
                        <td>{parseFloat(element.costo).toFixed(2)}</td>
                        <td>
                          {element.cantidad ? element.cantidad : "SIN NOMBRE"}
                        </td>
                        <td>{element.total.toFixed(2)}</td>
                      </tr>
                    );
                  })
                : ""}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setDetalleOrden([]);
              setMostrarDetalle(false);
            }}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
